var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Box, Button, Modal, Trans } from '@lucidlink/uicore';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { ModalActions } from '../components/ModalActions';
import { ModalDescription } from '../components/ModalDescription';
import { ModalTitle } from '../components/ModalTitle';
export const WorkspaceLimitModal = ({ canAccessBilling, closeModal, text, workspaceId, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    // eslint-disable-next-line @typescript-eslint/naming-convention -- injected component
    const WorkspaceLimitNavToBilling = useDependency(DEPENDENCY_KEYS.WorkspaceLimitNavToBilling);
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, modalWidth: "m", children: [_jsxs(Box, { gap: "s", orientation: "vertical", children: [_jsx(ModalTitle, { id: titleId, children: _jsx(Trans, { children: "Plan limit reached" }) }), _jsx(ModalDescription, { children: text })] }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "cancel-limit", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), canAccessBilling && (_jsx(WorkspaceLimitNavToBilling, { workspaceId: workspaceId }))] })] }));
};
_react_refresh_temp_1 = WorkspaceLimitModal;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceLimitModal");
_react_refresh_temp_2(WorkspaceLimitModal, "dpS05iEzf0JNEyqYamDqyI4u+sg=", false, () => [useDependency]);
